// @flow
import React from 'react';
import styled from 'styled-components';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Toggle from 'react-toggled';

import { getText } from '../../utils/scribeUtils';
import EditProfileModal from './EditProfileModal';

const LockerFinal = styled.div`
  position: absolute;
  left: -30px;
  font-size: ${props => props.fontSize}px;
`;

const Transcript = styled.div`
  color: #555555;
  margin-bottom: 5px;
  line-height: 2;
  font-size: ${props => props.fontSize}px;
`;

const TranscriptWeb = styled.div`
  color: ${props => props.background};
  margin-bottom: 5px;
  line-height: ${props => props.lineHeight}px;
  font-size: ${props => props.fontSize}px;
`;

type PropsFinal = {
  currentPlatform: string,
  features: FeatureMap,
  fontSize: number,
  lang: string,
  speakers: Object,
  theme: Object,
  transcripts: TranscriptMap,
  transcriptsFinal: Array<string>,
  user: Object,
};

class FinalTranscript extends React.PureComponent<{
  currentPlatform: string,
  features: FeatureMap,
  fontSize: number,
  lang: string,
  speaker: Object,
  theme: Object,
  transcript: Transcript,
  user: Object,
}> {
  render() {
    const {
      currentPlatform,
      features,
      fontSize,
      lang,
      speaker,
      theme,
      transcript,
      user,
    } = this.props;

    if (!getText(transcript, lang)) {
      return null;
    }

    return (
      <>
        {currentPlatform === 'scribe' && (
          <Transcript fontSize={fontSize}>
            <div style={{ position: 'relative' }}>
              {/* eslint-disable-next-line jsx-a11y/accessible-emoji */}
              {getText(transcript, lang).length > 0 && (
                <LockerFinal fontSize={fontSize}>
                  <i
                    className="material-icons"
                    style={{ color: theme.palette.primary.dark, opacity: 0.4 }}
                  >
                    lock
                  </i>
                </LockerFinal>
              )}
              <p>
                <span>
                  <strong>{transcript.author}</strong>:{' '}
                </span>
                {getText(transcript, lang)}
              </p>
            </div>
          </Transcript>
        )}
        {currentPlatform === 'web' && (
          <TranscriptWeb
            fontSize={fontSize}
            lineHeight={fontSize}
            background={theme.palette.text.primary}
          >
            <Grid container wrap="nowrap" spacing={16}>
              <Hidden xsDown>
                <Grid item>
                  {transcript.authorShow &&
                    speaker &&
                    speaker.userAvatar !== '' && (
                      <Avatar
                        key="avatar"
                        src={speaker.userAvatar}
                        alt="speaker_photo"
                        style={{
                          width: fontSize,
                          height: fontSize,
                          marginTop: fontSize / 5,
                        }}
                      />
                    )}
                  {currentPlatform === 'web' && (
                    <Grid
                      style={{
                        width: fontSize,
                        height: fontSize,
                        marginTop: fontSize / 5,
                      }}
                    />
                  )}
                </Grid>
              </Hidden>
              <Grid item xs css={{ lineHeight: 1 }}>
                <Toggle>
                  {({ on, getTogglerProps, setOff }) => (
                    <>
                      <Typography
                        variant="h5"
                        style={{
                          color: speaker
                            ? speaker.color
                            : theme.palette.error.light,
                          fontWeight: 'bold',
                          fontSize,
                          outline: 'none',
                          cursor:
                            speaker && speaker.id === user.avaId && 'pointer',
                        }}
                        {...getTogglerProps()}
                      >
                        {transcript.authorShow &&
                          speaker &&
                          speaker.userName && (
                            <strong key="name">{speaker.userName}</strong>
                          )}
                        {transcript.authorShow && !speaker && (
                          <strong>{transcript.author}</strong>
                        )}
                      </Typography>
                      {speaker && speaker.id === user.avaId && (
                        <EditProfileModal open={on} close={setOff} />
                      )}
                    </>
                  )}
                </Toggle>
                <div
                  style={{
                    opacity: features['dev-mode'] ? 0.7 : 1,
                    fontWeight: transcript.highlighted ? 'bold' : '',
                  }}
                >
                  {getText(transcript, lang)}
                </div>
              </Grid>
            </Grid>
          </TranscriptWeb>
        )}
      </>
    );
  }
}

// eslint-disable-next-line react/no-multi-comp
class FinalTranscriptList extends React.Component<PropsFinal> {
  shouldComponentUpdate(nextProps: PropsFinal) {
    const { transcriptsFinal, fontSize, theme, lang, speakers } = this.props;
    if (
      fontSize !== nextProps.fontSize ||
      theme !== nextProps.theme ||
      lang !== nextProps.lang ||
      speakers !== nextProps.speakers
    ) {
      return true;
    }
    return transcriptsFinal.length !== nextProps.transcriptsFinal.length;
  }

  render() {
    const {
      currentPlatform,
      features,
      fontSize,
      lang,
      speakers,
      theme,
      transcripts,
      transcriptsFinal,
      user,
    } = this.props;
    return transcriptsFinal.map<Object>(tid => (
      <FinalTranscript
        currentPlatform={currentPlatform}
        features={features}
        fontSize={fontSize}
        key={transcripts[tid].id}
        lang={lang}
        speaker={speakers[transcripts[tid].author]}
        theme={theme}
        transcript={transcripts[tid]}
        user={user}
      />
    ));
  }
}

export default FinalTranscriptList;
